import { render, staticRenderFns } from "./HomeworkCard.vue?vue&type=template&id=908ee488&scoped=true&"
import script from "./HomeworkCard.vue?vue&type=script&lang=js&"
export * from "./HomeworkCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkCard.vue?vue&type=style&index=0&id=908ee488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ee488",
  null
  
)

export default component.exports